export const clampScore = (score: number): number =>
  Math.max(0, Math.min(100, score));

// Math.floor, NOT Math.round (rev 5): the server stores a 2-decimal score and
// derives the tier from it — 89.5 is Gold. Rounding the display to "90" beside
// a Gold pill and a "90+ = Platinum" popover contradicts the tier system;
// flooring can never promote the displayed number across a boundary.
export const displayScore = (score: number): number =>
  Math.floor(clampScore(score));
